import settings from "../api/settings";

const redirectAssetsSource = (input: string) =>
  input.replace(/src="assets\//gi, `src="${settings.baseAddress}/assets/`);
const addVideoControls = (input: string) =>
  input.replace(/<video /g, "<video controls ");

export const processContentString = (input: string) =>
  redirectAssetsSource(addVideoControls(input));
